// extracted by mini-css-extract-plugin
export default {"network":"network-graph_network__deLZf"};